import {ShapeCommand} from '../commands.template';

export class StickerCreateCommand extends ShapeCommand {
  // protected firstAction: boolean;
  protected services: any;

  constructor(data) {
    super(data);
    // this.firstAction = true;
  }

  public execute() {
    super.execute();
    this.services.stickersSvc.switchVisible(false, true);

    const graph = this.services.editorRegistrySvc.getGraph();
    const stickerVertex = this.services.shapeSpawnerSvc.createSticker(this.object);

    graph.addCell(stickerVertex, this.services.graphHelperSvc.stickerParent());
    this.object.mxKey = Number(stickerVertex.id);
    this.executeJson(this.object);

    return stickerVertex;
  }

  private executeJson(data) {
    return this.services.diagramUpdateSvc.update({
      createNote: {
        mxKey: Number(data.mxKey),
        text: data.text,
        position: {
          x: data.position.x,
          y: data.position.y,
          w: data.position.w,
          h: data.position.h,
          rotation: data.position.rotation
        },
        paperClass: data.paperClass || 'yellow-paper-gold',
        tags: data.tags || []
      }
    });
  }

  public reverse() {
    super.reverse();
    const graph = this.services.editorRegistrySvc.getGraph();

    const stickerVertex = this.services.graphHelperSvc
      .allStickers()
      .find(cell => Number(cell.id) === Number(this.object.mxKey));

    graph.removeCells([stickerVertex], false);

    return this.reverseJson(this.object);
  }

  private reverseJson(data) {
    return this.services.diagramUpdateSvc.update({
      deleteNote: {
        mxKey: Number(data.mxKey)
      }
    });
  }
}
